import {detect} from 'detect-browser';
import { decodeDocument } from './documentsHelper';
const detectedBrowser = detect();

export const openPdfBase64Bit = (pdfString64bit , fileName) => {
  {
    if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE workaround
      const byteCharacters = decodeDocument(pdfString64bit);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], {type: 'application/pdf'});
      window.navigator.msSaveOrOpenBlob(blob, fileName);
    }
    else { // much easier if not IE
      let pdfWindow = window.open("");
      const src = `'data:application/pdf;base64, ${encodeURI(pdfString64bit)}'` ;

      // pdfWindow.document.write("<iframe width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(pdfString64bit) + "'></iframe>") ;
      pdfWindow.document.write(`<iframe width='100%'
                                        name=${fileName}
                                        type="application/pdf"
                                        allowfullscreen
                                        height='100%'
                                        src=${ src }></iframe>`) ;
    }
  }
};

export const downloadPdf64Bit = (pdfString64bit , fileName , withHeader = true) => {
  {
    const linkSource = withHeader ? `data:application/pdf;headers=filename%3D${fileName};base64, ${encodeURI(pdfString64bit)}` : pdfString64bit;
    const downloadLink = document.createElement("a");
    const _fileName = fileName;

    downloadLink.href = linkSource;
    downloadLink.download = _fileName;
    downloadLink.click();
  }
};

function base64toBlob(base64Data, contentType) {
  contentType = contentType || '';
  const sliceSize = 1024;
  const byteCharacters = decodeDocument(base64Data);
  const bytesLength = byteCharacters.length;
  const slicesCount = Math.ceil(bytesLength / sliceSize);
  const byteArrays = new Array(slicesCount);

  for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
    const begin = sliceIndex * sliceSize;
    const end = Math.min(begin + sliceSize, bytesLength);

    const bytes = new Array(end - begin);
    for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
      bytes[i] = byteCharacters[offset].charCodeAt(0);
    }
    byteArrays[sliceIndex] = new Uint8Array(bytes);
  }
  return new Blob(byteArrays, { type: contentType });
}

function blobUrl(content, mimeType) {
  const blob = base64toBlob(content, mimeType);
  return URL.createObjectURL(blob);
}

export function generatePdfOpenProps(data, name) {
  switch (detectedBrowser && detectedBrowser.name) {

    case 'chrome':
    case 'firefox':
      return {
        name,
        target: '_blank',
        href: blobUrl(data, 'application/pdf'),
      };

    case 'safari':
    case 'ios':
      return {
        target: '_blank',
        href: `data:application/pdf;charset=utf-8;base64,${data}`,
      };

    case 'edge':
    case 'ie':
    default:
      return {
        download: name,
        href: blobUrl(data, 'application/pdf'),
      };
  }
}


export function generateBrowser() {
  if (detectedBrowser && detectedBrowser.name) {
    return detectedBrowser;
  }
 }



// WEBPACK FOOTER //
// ./src/utils/pdfHelper.js